import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, tap } from 'rxjs';
import { ConfigRepository } from '../../../../../../shared/repositories/config.repository';
import { BreakpointService } from '../../../../../../shared/services/breakpoint.service';
import { Outlet } from '../../../../../../api/v1/models/outlet';
import { map } from 'rxjs/operators';
import { zeroMaskFromTimeInterval } from '../../../../../../shared/utils/get-time-intervals';
import { FormSaveStrategy } from '../../../../../common/strategy/form-save-strategy/form-save-strategy.abstract';

interface Schedule {
  open: string,
  close: string,
  dayKey: string,
  isOpen: boolean,
}

@Component({
  selector: 'app-resto-select',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './resto-select.component.html',
  styleUrls: ['./resto-select.component.scss']
})
export class RestoSelectComponent {
  constructor(
    private configRepository: ConfigRepository,
    public breakPoint: BreakpointService,
    private formSaveStrategy: FormSaveStrategy,
  ) {}

  pickupAddress$ = this.configRepository.address$;

  activeOutletId: number = this.configRepository.activeOutletId;

  public outletsSchedule: { [key: string]: Schedule | null };
  public outlets$: Observable<Outlet[]> = this.configRepository.outlets$.pipe(
    map((outlets => outlets.sort((a, b) => (a.addressDetails?.city || '') > (b.addressDetails?.city || '') ? 1 : -1))),
    tap((outlets: Outlet[]) => {
      this.outletsSchedule = {};
      outlets.forEach((outlet: Outlet) => {
        this.outletsSchedule[outlet.storeId] = this.getOutletSchedule(outlet);
      })
    })
  );

  private getOutletSchedule(outlet: Outlet): Schedule | null {
    let schedule: Schedule | null = null;
    const currentDayName: string = new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(new Date());

    if (!outlet.workingIntervals[currentDayName]) { return null }

    const dayHours = outlet.workingIntervals[currentDayName];
    schedule = {
      dayKey: currentDayName,
      open: zeroMaskFromTimeInterval(dayHours.at(0)?.open),
      close: zeroMaskFromTimeInterval(dayHours.at(-1)?.close),
      isOpen: this.configRepository.getOpenStateOutlet(dayHours),
    }

    return schedule;
  }

  onChangeMenu(id: number): void {
    if (id === this.activeOutletId) { return }
    this.activeOutletId = id;
    this.formSaveStrategy.setActiveOutlet(id, true)
  }
}
